import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = "Employee/RiskManagerWithSales";

export function CasRHFRiskWithSalesManagerSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasRiskWithSalesManagerSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
